document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.violex-product-gallery').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('.violex-product-gallery__slide'));
    const dots = Array.from(gallery.querySelectorAll('.violex-product-gallery__dot'));
    const prevBtn = gallery.querySelector('.violex-product-gallery__arrow--prev');
    const nextBtn = gallery.querySelector('.violex-product-gallery__arrow--next');
    const lightbox = gallery.parentElement.querySelector('.violex-product-lightbox');

    if (!slides.length) return;

    let current = 0;

    function showSlide(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    }

    prevBtn && prevBtn.addEventListener('click', () => showSlide(current - 1));
    nextBtn && nextBtn.addEventListener('click', () => showSlide(current + 1));

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => showSlide(i));
    });

    slides.forEach((slide, i) => {
      slide.addEventListener('click', () => {
        if (i === current) openLightbox(i);
      });
    });

    showSlide(0);

    if (!lightbox) return;

    const lightboxImg = lightbox.querySelector('img');
    const closeBtn = lightbox.querySelector('.violex-product-lightbox__close');
    const backdrop = lightbox.querySelector('.violex-product-lightbox__backdrop');
    const lbPrev = lightbox.querySelector('.violex-product-lightbox__arrow--prev');
    const lbNext = lightbox.querySelector('.violex-product-lightbox__arrow--next');

    function openLightbox(index) {
      current = index;
      lightboxImg.src = slides[current].dataset.fullSrc;
      lightboxImg.alt = slides[current].querySelector('img').alt;
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightboxImg.src = '';
      document.body.style.overflow = '';
      showSlide(current);
    }

    function lightboxShow(index) {
      current = (index + slides.length) % slides.length;
      lightboxImg.src = slides[current].dataset.fullSrc;
      lightboxImg.alt = slides[current].querySelector('img').alt;
    }

    closeBtn && closeBtn.addEventListener('click', closeLightbox);
    backdrop && backdrop.addEventListener('click', closeLightbox);
    lbPrev && lbPrev.addEventListener('click', () => lightboxShow(current - 1));
    lbNext && lbNext.addEventListener('click', () => lightboxShow(current + 1));

    document.addEventListener('keydown', (e) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxShow(current - 1);
      if (e.key === 'ArrowRight') lightboxShow(current + 1);
    });
  });
});
